import { render, staticRenderFns } from "./EventModalManagers.vue?vue&type=template&id=b520d54e&scoped=true"
import script from "./EventModalManagers.vue?vue&type=script&lang=js"
export * from "./EventModalManagers.vue?vue&type=script&lang=js"
import style0 from "./EventModalManagers.vue?vue&type=style&index=0&id=b520d54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b520d54e",
  null
  
)

export default component.exports